import * as React from "react";

import { cn } from "@/lib/utils.js";

/**
 * Input component - Styled form input field
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.type] - Input type (text, email, password, etc.)
 * @param {React.Ref<HTMLInputElement>} ref - Forwarded ref
 * @param {...Object} props - Other input HTML attributes
 * @returns {JSX.Element} Input field
 */
const Input = React.forwardRef(
  /** @param {{ className?: string, type?: string, [key: string]: any }} props */
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "block w-full bg-card border border-input rounded px-3 py-2",
          "text-sm font-light leading-6 text-foreground",
          "h-[calc(1.5em_+_0.75rem_+_2px)]",
          "transition-all duration-150 ease-in-out",
          "focus:outline-none focus:border-border focus:ring-1 focus:ring-border",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted",
          "placeholder:text-muted-foreground",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
